import { Button, Card, CardBody, CardHeader, CardTitle, Col, FormGroup, InputGroup, Input, InputGroupAddon, Label, Row, Spinner } from "reactstrap";
import * as Yup from "yup";
import { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import SelectUf from "../../../../../components/Select/SelectUf/index";
import SelectSexo from "../../../../../components/Select/SelectSexo/index";
import SelectEstadoCivil from "../../../../../components/Select/SelectEstadoCivil/index";
import SelectMunicipio from "../../../../../components/Select/SelectMunicipio/index";
import { options as optionsMunicipio } from "../../../../../components/Select/SelectMunicipio/options";
import { options as optionsUf } from "../../../../../components/Select/SelectUf/options";
import { options as optionsSexo } from "../../../../../components/Select/SelectSexo/options";
import { options as optionsEstadoCivil } from "../../../../../components/Select/SelectEstadoCivil/options";
import { cpfMask, dateMask } from "../../../../../utils/mask";
import Error from "../../../../../components/messagesModal/error";
import BaseService from "../../../../../services/baseService";
import { actions as actionsSite } from "../../../../../redux/actions/site";

const baseService = new BaseService("consulta");

const Step1 = ({ values, setValues, setCurrentStep }) => {
  const dispatch = useDispatch();
  const [isSubmittingCpf, setIsSubmittingCpf] = useState(false);
  const [isSubmittingCep, setIsSubmittingCep] = useState(false);
  const [sexoValue, setSexoValue] = useState();
  const [estadoCivilValue, setEstadoCivilValue] = useState();
  const [naturalidadeUfValue, setNaturalidadeUfValue] = useState();
  const [ufValue, setUfValue] = useState();
  const [naturalidadeValue, setNaturalidadeValue] = useState();

  const validationSchema = Yup.object().shape({
    nome: Yup.string().required("Nome é obrigatório"),
    cpf: Yup.string().required("CPF é obrigatório").cpfCnpj("CPF inválido"),
    data_nascimento: Yup.string()
      .required("Data Nascimento é obrigatória")
      .matches(/^\d{2}\/\d{2}\/\d{4}$/, 'Formato de data inválido (DD/MM/YYYY)')
      .test('isValidDate', 'Data inválida', function (value) {
        if (!value) return true;
        const [day, month, year] = value.split('/').map(Number);
        const dateObject = new Date(year, month - 1, day);

        return (
          dateObject.getFullYear() === year &&
          dateObject.getMonth() === month - 1 &&
          dateObject.getDate() === day
        );
      })
      .test('isMinimumAge', 'Devedor precisa ter pelo menos 18 anos', function (value) {
        if (!value) return true;
        const [day, month, year] = value.split('/').map(Number);
        const today = new Date();
        const minimumAgeDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
        const inputDate = new Date(year, month - 1, day);
        return inputDate <= minimumAgeDate;
      })
      .test('isMaximumAge', 'Devedor precisa ter no máximo 120 anos', function (value) {
        if (!value) return true;
        const [day, month, year] = value.split('/').map(Number);
        const today = new Date();
        const maximumAgeDate = new Date(today.getFullYear() - 120, today.getMonth(), today.getDate());
        const inputDate = new Date(year, month - 1, day);
        return inputDate >= maximumAgeDate;
      }),
    sexo: Yup.string().required("Sexo é obrigatório").uppercase().oneOf(['M', 'F'], "Sexo é inválido"),
    estado_civil: Yup.string().required("Estado Civil é obrigatório").uppercase().oneOf(['C', 'D', 'S', 'V'], "Estado Civil é inválido"),
    naturalidade_uf: Yup.string().required('A UF é obrigatória').uppercase().oneOf(['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'], "UF de Naturalidade é inválido"),
    naturalidade: Yup.string().required("Naturalidade é obrigatória"),
    cep: Yup.string().required("Cep é obrigatório"),
    uf: Yup.string().required('A UF é obrigatória').uppercase().oneOf(['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'], "UF inválido"),
    cidade: Yup.string().required("Cidade é obrigatório"),
    bairro: Yup.string().required("Bairro é obrigatório"),
    logradouro: Yup.string().required("Logradouro é obrigatório"),
    numero: Yup.string().required("Número é obrigatório"),
    email: Yup.string().required("Email é obrigatório").email("E-mail é inválido"),
  });

  const getDados = async () => {
    try {
      setIsSubmittingCpf(true);
      const payload = { cpf: formData.cpf };
      await baseService._postConsulta(`${baseService.route}/pf-localiza`, payload)
        .then((res) => {
          if (res.success) {
            const dados = res.dados;
            setFormData({
              ...formData,
              data_nascimento: dados.data_nascimento,
              sexo: dados.genero
            });

            handleSetSexoValue(dados.genero);
          } else {
            const configModal = {
              component: <Error msg={res.msg} />,
              title: `Erro`,
            };
            dispatch(actionsSite.setModal(configModal));
          }
        })
        .catch((error) => {
          if (error.response) {
            const configModal = {
              component: <Error msg={error.response.data.msg} />,
              title: `Erro`,
            };
            dispatch(actionsSite.setModal(configModal));
          }
        });
        setIsSubmittingCpf(false);
    } catch (e) {
      console.log(e.toString());
      setIsSubmittingCpf(false);
    }
  };

  const validate = async () => {
    try {
      await validationSchema.validate(formData, { abortEarly: false });

      setErrors({});
      setValues(formData);
      setCurrentStep(1);
      return true;
    } catch (error) {
      const validationErrors = {};
      error.inner.forEach((err) => {
        validationErrors[err.path] = err.message;
      });

      setErrors(validationErrors);

      return false;
    }
  };

  const onlyNumbers = (value) => {
    return value.replace(/[^\d]/g, '');
  }

  const toLowerCase = (value) => {
    return value.toLowerCase();
  }

  const getEndereco = async () => {
    setIsSubmittingCep(true);
    const cep = formData.cep;
    await fetch(`https://viacep.com.br/ws/${cep}/json`, { method: 'GET'})
      .then(response => {
        if (!response.ok) {
          throw new Error('Erro na requisição');
        }
        return response.json();
      })
      .then(data => {
        setFormData({
          ...formData,
          uf: data.uf,
          cidade: data.localidade,
          logradouro: data.logradouro,
          bairro: data.bairro
        });

        handleSetUfValue(data.uf);
      }).catch(error => {
        console.log(error);
      });
    setIsSubmittingCep(false);
  }

  const handleSetSexoValue = (value) => {
    const _sexoValue = optionsSexo.find(s => s.value === value);
    setSexoValue(_sexoValue);
  }

  const handleSetEstadoCivilValue = (value) => {
    const _estadoCivilValue = optionsEstadoCivil.find(e => e.value === value);
    setEstadoCivilValue(_estadoCivilValue);
  }

  const handleSetNaturalidadeUfValue = (value) => {
    const _naturalidadeUfValue = optionsUf.find(uf => uf.value === value);
    setNaturalidadeUfValue(_naturalidadeUfValue);
  }

  const handleSetNaturalidadeValue = (value) => {
    const _naturalidadeValue = optionsMunicipio.find(opt => opt.value === value);
    setNaturalidadeValue(_naturalidadeValue);
  }

  const handleSetUfValue = (value) => {
    const _uf = optionsUf.find(uf => uf.value === value);
    setUfValue(_uf);
  }

  useEffect(() => {
    if (values.sexo) {
      handleSetSexoValue(values.sexo);
    }

    if (values.estado_civil) {
      handleSetEstadoCivilValue(values.estado_civil);
    }

    if (values.naturalidade_uf) {
      handleSetNaturalidadeUfValue(values.naturalidade_uf);
    }

    if (values.naturalidade) {
      handleSetNaturalidadeValue(values.naturalidade);
    }

    if (values.uf) {
      handleSetUfValue(values.uf);
    }

    setFormData({
      nome: values.nome,
      cpf: values.cpf,
      data_nascimento: values.data_nascimento,
      sexo: values.sexo,
      estado_civil: values.estado_civil,
      naturalidade: values.naturalidade,
      naturalidade_uf: values.naturalidade_uf,
      cep: values.cep,
      uf: values.uf,
      cidade: values.cidade,
      bairro: values.bairro,
      logradouro: values.logradouro,
      numero: values.numero,
      complemento: values.complemento,
      email: values.email,
    });
  }, [values])

  const [formData, setFormData] = useState({
    nome: '',
    cpf: '',
    data_nascimento: '',
    sexo: '',
    estado_civil: '',
    naturalidade: '',
    naturalidade_uf: '',
    cep: '',
    uf: '',
    cidade: '',
    bairro: '',
    logradouro: '',
    numero: '',
    complemento: '',
    email: '',
  });

  const [errors, setErrors] = useState({
    nome: '',
    cpf: '',
    data_nascimento: '',
    sexo: '',
    estado_civil: '',
    naturalidade: '',
    naturalidade_uf: '',
    cep: '',
    uf: '',
    cidade: '',
    bairro: '',
    logradouro: '',
    numero: '',
    complemento: '',
    email: '',
  });

  const setFieldValue = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <Fragment>
      <Card className="border-custom">
        <CardHeader className="card-custom">
          <CardTitle className="card-text-custom">Dados Pessoais do Devedor</CardTitle>
        </CardHeader>
        <CardBody>
          <Row>
            <Col sm="6" md="4">
              <Label htmlFor="cpf"><span className="text-danger">***</span> CPF</Label>
              <InputGroup>
                <Input
                  type="text"
                  name="cpf"
                  id="cpf"
                  placeholder="Digite o CPF"
                  onChange={(e) => setFieldValue('cpf', cpfMask(e.target.value))}
                  onBlur={() => getDados()}
                  value={formData.cpf}
                  className={"form-control" + (errors.cpf ? " is-invalid" : "")}
                />
                <InputGroupAddon addonType="append">
                <Button type="button" color="primary" onClick={() => getDados()} disabled={!formData.cpf || isSubmittingCpf}>
                  {isSubmittingCpf ? <Spinner color="light" size="sm" className="mr-1" /> : <i className="fa-solid fa-magnifying-glass"></i>}
                </Button>
                </InputGroupAddon>
                <div className="invalid-feedback">{errors.cpf}</div>
              </InputGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="nome"><span className="text-danger">***</span> Nome</Label>
                <Input
                  type="text"
                  name="nome"
                  id="nome"
                  placeholder="Digite o Nome"
                  className={"form-control" + (errors.nome ? " is-invalid" : "")}
                  onChange={(e) => setFieldValue('nome', e.target.value)}
                  value={formData.nome}
                />
                <div className="invalid-feedback">{errors.nome}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="data_nascimento"><span className="text-danger">***</span> Data Nascimento</Label>
                <Input
                  type="text"
                  name="data_nascimento"
                  id="data_nascimento"
                  placeholder={isSubmittingCpf ? "..." : "Digite a Data de Nascimento"}
                  className={"form-control" + (errors.data_nascimento ? " is-invalid" : "")}
                  onChange={(e) => setFieldValue('data_nascimento', dateMask(e.target.value))}
                  value={formData.data_nascimento}
                  maxLength="10"
                  disabled={isSubmittingCpf}
                />
                <div className="invalid-feedback">{errors.data_nascimento}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="sexo"><span className="text-danger">***</span> Sexo</Label>
                <SelectSexo
                  name="sexo"
                  id="sexo"
                  placeholder={isSubmittingCpf ? "..." : "Selecione o Sexo"}
                  className={errors.sexo ? "is-invalid invalid-multi-select" : ""}
                  onChange={(data) => { setFieldValue("sexo", data ? data.value : ""); handleSetSexoValue(data.value) }}
                  isSearchable={true}
                  isClearable={true}
                  value={sexoValue}
                  disabled={isSubmittingCpf}
                />
                <div className="invalid-feedback">{errors.sexo}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="estado_civil"><span className="text-danger">***</span> Estado Civil</Label>
                <SelectEstadoCivil
                  name="estado_civil"
                  id="estado_civil"
                  placeholder="Selecione o Estado Civil"
                  className={errors.estado_civil ? "is-invalid invalid-multi-select" : ""}
                  onChange={(data) => { setFieldValue("estado_civil", data ? data.value : ""); handleSetEstadoCivilValue(data.value) }}
                  isSearchable={true}
                  isClearable={true}
                  value={estadoCivilValue}
                />
                <div className="invalid-feedback">{errors.estado_civil}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="naturalidade_uf"><span className="text-danger">***</span> UF Naturalidade</Label>
                <SelectUf
                  name="naturalidade_uf"
                  id="naturalidade_uf"
                  placeholder="Selecione a UF de Naturalidade"
                  className={errors.naturalidade_uf ? "is-invalid invalid-multi-select" : ""}
                  onChange={(data) => { setFieldValue("naturalidade_uf", data ? data.value : ""); handleSetNaturalidadeUfValue(data.value) }}
                  isSearchable={true}
                  isClearable={true}
                  value={naturalidadeUfValue}
                />
                <div className="invalid-feedback">{errors.naturalidade_uf}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="naturalidade"><span className="text-danger">***</span> Cidade Naturalidade</Label>
                <SelectMunicipio
                  name="naturalidade"
                  placeholder="Selecione uma Cidade"
                  className={errors.naturalidade ? "is-invalid invalid-multi-select" : ""}
                  onChange={(data) => { setFieldValue("naturalidade", data ? data.value : ""); handleSetNaturalidadeValue(data.value) }}
                  isSearchable={true}
                  isClearable={true}
                  value={naturalidadeValue}
                />
                <div className="invalid-feedback">{errors.naturalidade}</div>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>

        <CardHeader className="card-custom">
          <CardTitle className="card-text-custom">Endereço do Devedor</CardTitle>
        </CardHeader>
        <CardBody>
          <Row>
            <Col sm="6" md="4">
              <Label htmlFor="cep"><span className="text-danger">***</span> Cep</Label>
              <InputGroup>
                <Input
                  type="text"
                  name="cep"
                  id="cep"
                  placeholder="Digite o Cep"
                  onChange={(e) => setFieldValue('cep', e.target.value)}
                  value={formData.cep}
                  className={"form-control" + (errors.cep ? " is-invalid" : "")}
                  onBlur={() => getEndereco()}
                />
                <InputGroupAddon addonType="append">
                <Button type="button" color="primary" onClick={() => getEndereco()} disabled={!formData.cep || isSubmittingCep}>
                  {isSubmittingCep ? <Spinner color="light" size="sm" className="mr-1" /> : <i className="fa-solid fa-magnifying-glass"></i>}
                </Button>
                </InputGroupAddon>
                <div className="invalid-feedback">{errors.cep}</div>
              </InputGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="uf"><span className="text-danger">***</span> UF</Label>
                <SelectUf
                  name="uf"
                  id="uf"
                  placeholder={isSubmittingCep ? "..." : "Selecione a UF"}
                  className={errors.uf ? "is-invalid invalid-multi-select" : ""}
                  onChange={(data) => { setFieldValue("uf", data ? data.value : ""); handleSetUfValue(data.value) }}
                  isSearchable={true}
                  isClearable={true}
                  value={ufValue}
                  disabled={isSubmittingCep}
                />
                <div className="invalid-feedback">{errors.uf}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="cidade"><span className="text-danger">***</span> Cidade</Label>
                <Input
                  type="text"
                  name="cidade"
                  id="cidade"
                  placeholder="Digite a Cidade"
                  className={"form-control" + (errors.cidade ? " is-invalid" : "")}
                  onChange={(e) => setFieldValue('cidade', e.target.value)}
                  value={isSubmittingCep ? "..." : formData.cidade}
                  disabled={isSubmittingCep}
                />
                <div className="invalid-feedback">{errors.cidade}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="bairro"><span className="text-danger">***</span> Bairro</Label>
                <Input
                  type="text"
                  name="bairro"
                  id="bairro"
                  placeholder="Digite o Bairro"
                  value={isSubmittingCep ? "..." : formData.bairro}
                  onChange={(e) => setFieldValue('bairro', e.target.value)}
                  className={"form-control" + (errors.bairro ? " is-invalid" : "")}
                  disabled={isSubmittingCep}
                />
                <div className="invalid-feedback">{errors.bairro}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="logradouro"><span className="text-danger">***</span> Logradouro</Label>
                <Input
                  type="text"
                  name="logradouro"
                  id="logradouro"
                  placeholder="Digite o Logradouro"
                  value={isSubmittingCep ? "..." : formData.logradouro}
                  onChange={(e) => setFieldValue('logradouro', e.target.value)}
                  className={"form-control" + (errors.logradouro ? " is-invalid" : "")}
                  disabled={isSubmittingCep}
                />
                <div className="invalid-feedback">{errors.logradouro}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="numero"><span className="text-danger">***</span> Número</Label>
                <Input
                  type="text"
                  name="numero"
                  id="numero"
                  placeholder="Digite o Número"
                  value={formData.numero}
                  onChange={(e) => setFieldValue('numero', e.target.value)}
                  onKeyUp={(e) => setFieldValue('numero', onlyNumbers(e.target.value))}
                  className={"form-control" + (errors.numero ? " is-invalid" : "")}
                />
                <div className="invalid-feedback">{errors.numero}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="complemento">Complemento</Label>
                <Input
                  type="text"
                  name="complemento"
                  id="complemento"
                  placeholder="Digite o Complemento"
                  onChange={(e) => setFieldValue('complemento', e.target.value)}
                  value={formData.complemento}
                  className={"form-control" + (errors.complemento ? " is-invalid" : "")}
                />
                <div className="invalid-feedback">{errors.complemento}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="email"><span className="text-danger">***</span> Email</Label>
                <Input
                  type="text"
                  name="email"
                  id="email"
                  placeholder="Digite o Email"
                  className={"form-control" + (errors.email ? " is-invalid" : "")}
                  onChange={(e) => setFieldValue('email', e.target.value)}
                  onKeyUp={(e) => setFieldValue('email', toLowerCase(e.target.value))}
                  value={formData.email}
                />
                <div className="invalid-feedback">{errors.email}</div>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <div className="text-center">
        <Button className="mr-1" color="primary" onClick={validate}>Próximo</Button>
      </div>
    </Fragment>
  );
};

export default Step1;